package linkerpangoquipdb

import kotlin.String

public data class SelectAllModelsWithBrandName(
  public val brand_name: String,
  public val model_name: String,
)
